import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

const WEBSOCKET_URL = process.env.REACT_APP_WS_URL || 'http://localhost:3001';

export const useWebSocket = (onLocationUpdate, onVolunteerLogin, onVolunteerLogout, onEventRegistered) => {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [connectionError, setConnectionError] = useState(null);

  useEffect(() => {
    // Initialize socket connection
    socketRef.current = io(WEBSOCKET_URL, {
      transports: ['websocket', 'polling'],
      timeout: 20000,
    });

    const socket = socketRef.current;

    // Connection event handlers
    socket.on('connect', () => {
      console.log('WebSocket connected:', socket.id);
      setIsConnected(true);
      setConnectionError(null);
    });

    socket.on('disconnect', (reason) => {
      console.log('WebSocket disconnected:', reason);
      setIsConnected(false);
      
      if (reason === 'io server disconnect') {
        // Server disconnected, try to reconnect
        socket.connect();
      }
    });

    socket.on('connect_error', (error) => {
      console.error('WebSocket connection error:', error);
      setIsConnected(false);
      setConnectionError(error.message);
    });

    // Volunteer login handler
    socket.on('volunteer_login', (data) => {
      console.log('Volunteer login:', data);
      if (onVolunteerLogin) {
        onVolunteerLogin(data);
      }
    });

    // Volunteer logout handler
    socket.on('volunteer_logout', (data) => {
      console.log('Volunteer logout:', data);
      if (onVolunteerLogout) {
        onVolunteerLogout(data);
      }
    });

    // Event registration handler
    socket.on('event_registered', (data) => {
      console.log('Event registered:', data);
      if (onEventRegistered) {
        onEventRegistered(data);
      }
    });

    // Cleanup on unmount
    return () => {
      if (socket) {
        socket.disconnect();
      }
    };
  }, [onVolunteerLogin, onVolunteerLogout, onEventRegistered]);

  // Join specific view room
  const joinView = (viewType) => {
    if (socketRef.current && isConnected) {
      socketRef.current.emit('join_view', viewType);
      console.log(`Joined view: ${viewType}`);
    }
  };

  // Leave specific view room
  const leaveView = (viewType) => {
    if (socketRef.current && isConnected) {
      socketRef.current.emit('leave_view', viewType);
      console.log(`Left view: ${viewType}`);
    }
  };

  return {
    isConnected,
    connectionError,
    joinView,
    leaveView,
  };
};